import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  detailPanel: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
  },
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  iconVoltar: {
    marginRight: theme.spacing(1),
  },
  titleCampo: {
    fontSize: '13px',
    marginTop: theme.spacing(2),
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  containerCampos: {
    paddingBottom: theme.spacing(3),
    borderLeft: '1px solid #CCC',
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      borderLeft: 'none',
      paddingLeft: 0,
    },
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2.5),
  },
  buttons: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  cabecalhoBotao: {
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  botaoSalvar: {
    marginTop: '20px',
    marginBottom: '40px',
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: 0,
      '& button': {
        width: '100%',
      },
    },
  },
  positive: {
    color: theme.palette.primary.main,
  },
  negative: {
    color: theme.palette.error.light,
  },
  addIcon: {
    marginRight: theme.spacing(1),
  },
  tableContainer: {
    paddingBottom: theme.spacing(2),
  },
  vestigioCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: '12px',
    boxShadow: 'none',
  },
  cadaverCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '12px',
    boxShadow: 'none',
    transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
      borderColor: theme.palette.primary.main,
    },
  },
  expandedFormContainer: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  chipStatusSuccess: {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '12px',
    backgroundColor: 'rgba(76, 175, 80, 0.12)',
    color: '#4caf50',
    fontSize: '11px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  chipStatusWarning: {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 152, 0, 0.12)',
    color: '#ff9800',
    fontSize: '11px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
}))
